import { getStatus } from '@/shared/config/missions'
import type { MissionWithProgress } from '@/types/mission'

import type { MissionShowStatus } from '../constants/showStatus'

export const getMissionShowStatus = (
  mission: MissionWithProgress | null | undefined
): MissionShowStatus => {
  if (!mission) return 'not_started'

  const submissionStatus =
    mission._progress?.submission?.status ?? mission._progress?.status

  /* A entrega é fato, não janela: concluída segue concluída depois do prazo. */
  if (submissionStatus === 'approved' || mission._progress?.finished) {
    return 'approved'
  }

  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  if (timeStatus?.slug === 'soon') return 'not_started'

  /* Sem como reenviar depois do prazo, recusa e correção viram "encerrada". */
  if (
    submissionStatus === 'refused' ||
    submissionStatus === 'awaiting_correction'
  ) {
    if (timeStatus?.slug === 'closed') return 'expired'
    return submissionStatus === 'refused' ? 'refused' : 'available'
  }

  /* A revisão do produtor acontece depois do encerramento: pendência dele não
     apaga a evidência enviada. */
  if (submissionStatus === 'pending') return 'pending'

  if (timeStatus?.slug === 'closed') return 'expired'

  return 'available'
}

/* O corte de envio espelha `Mission#closed?` da api — fora da janela é `soon`
   ou `closed`, e a api recusa as duas com 422. Não depende do showStatus:
   `pending` vence `expired` nele, mas nunca libera envio fora do prazo. */
const isMissionWindowOpen = (
  mission: MissionWithProgress | null | undefined
): boolean => {
  if (!mission) return false

  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  return timeStatus?.slug === 'open'
}

export const canSubmitEvidence = (
  mission: MissionWithProgress | null | undefined,
  options: { isCapacityFull: boolean }
): boolean => {
  if (!mission) return false
  if (!isMissionWindowOpen(mission)) return false

  const showStatus = getMissionShowStatus(mission)
  if (options.isCapacityFull) return false
  if (showStatus === 'pending' || showStatus === 'approved') return false

  return showStatus === 'available' || showStatus === 'refused'
}

export const canResubmitEvidence = (
  mission: MissionWithProgress | null | undefined,
  options: { isCapacityFull: boolean }
): boolean => {
  if (!mission) return false
  if (!isMissionWindowOpen(mission)) return false

  const showStatus = getMissionShowStatus(mission)
  if (options.isCapacityFull) return false
  if (showStatus === 'approved') return false

  return showStatus === 'pending' || showStatus === 'refused'
}
